export const apiKey = process.env.API_KEY || process.env.REACT_APP_API_KEY;
export const apiUrl = process.env.API_URL || process.env.REACT_APP_API_URL;
export const PLATFORM_ID = "084b35e0-b84a-4ded-92c7-ce2dfc581732";
